import React from "react";
import Chart from "react-apexcharts";
import { defaultChartThemeConfig } from "./defaultChartTheme";

const ApexChart = ({ chartConfig, seriesData, chartTheme = defaultChartThemeConfig }) => {
  if (chartConfig["type"] === "2d" || chartConfig["dimension"] === "2d") {
    seriesData = data2D;
  } else if (chartConfig["type"] === "3d" || chartConfig["dimension"] === "3d") {
    seriesData = data3D;
  }
  const getChartConfig = () => {
    const seriesDataCopy = structuredClone(seriesData);
    const { data, categories } = createSeriesAndCategories(seriesDataCopy, chartConfig);
    const config = createChartConfig(data, categories, chartConfig);

    return config;
  };
  let config = getChartConfig();

  config = {
    ...config,
    ...chartTheme
  };

  const chart_styles = chartConfig?.chart_styles || {};
  let chartElement = null;

  if (["spark_pie", "spark_line", "spark_area", "spark_column", "donut"].includes(chartConfig["chart_type"])) {
    chartElement = (
      //   <div className="spark_chart" style={{ margin: marginFlag ? "0 10px" : "0", ...(chart_styles?.chart_css || {}) }}>
      <div className="spark_chart" style={{ margin: "0 10px", height: "100%", ...(chart_styles?.chart_css || {}) }}>
        {chartConfig["title"] && (
          <p className="z-chart-title" style={{ fontSize: "16px", ...(chart_styles?.title_css || {}) }}>
            {chartConfig?.title}
          </p>
        )}
        <Chart options={{ ...config }} series={config.series} type={config.options.chart.type} height={"100%"} />
      </div>
    );
  } else {
    chartElement = (
      <Chart
        options={{ ...config }}
        // options={config.options}
        series={config.series}
        type={config.options.chart.type}
        // height={350}
        height={"100%"}
        // width={isRvChart ? 350 : undefined}
      />
    );
  }

  return chartElement;
};

export default ApexChart;

const getSparkChartType = (chartType) => {
  let chart = null;

  if (chartType === "spark_area") {
    chart = "area";
  } else if (chartType === "spark_line") {
    chart = "line";
  } else if (chartType === "spark_pie") {
    chart = "pie";
  } else if (chartType === "spark_column") {
    chart = "bar";
  }

  return chart;
};

const createChartConfig = (seriesData, categories, chartConfig) => {
  let config = structuredClone(chartDefaultConfig);

  //Standard setting
  config.options.title.text = chartConfig?.title;
  config.options.subtitle.text = chartConfig?.sub_title;
  config.options.xaxis.title.text = chartConfig?.xaxis_title;
  config.options.yaxis.title.text = chartConfig?.yaxis_title;
  config.series = seriesData;
  config.options.xaxis.categories = categories;

  switch (chartConfig.chart_type) {
    case "line":
      config.options.chart.type = "line";
      break;
    case "bar":
      config.options.chart.type = chartConfig.chart_type;
      config.options.plotOptions = {
        bar: {
          horizontal: chartConfig?.axis_inverted || false, // Set to true to swap the axes
          columnWidth: "55%",
          endingShape: "rounded"
        }
      };
      config.options.stroke.show = false;
      config.options.xaxis.tickAmount = 10;
      config.options.xaxis.min = 0;

      break;
    case "pie":
      config.series = seriesData[0].data;
      config.options.chart.type = chartConfig.chart_type;
      config.options.labels = categories;
      config.options.plotOptions = {
        pie: {
          expandOnClick: true,
          dataLabels: {
            offset: 0
          }
        }
      };
      break;
    case "spark_line":
    case "spark_area":
    case "spark_pie":
    case "spark_column":
      config.options.chart.type = getSparkChartType(chartConfig.chart_type);
      config.options.title = {};
      config.options.dataLabels.enabled = false;
      config.options.grid.show = false;
      config.options.xaxis.axisBorder.show = true;
      config.options.xaxis.labels.show = false;
      config.options.xaxis.tooltip.enabled = false;
      config.options.xaxis.axisTicks.show = false;
      config.options.yaxis.axisTicks.show = false;
      config.options.yaxis.labels.show = false;
      config.options.legend.show = false;
      config.options.grid = { show: false };
      config.options.markers = { size: 0 }; //remove dot on the top of the line

      if (chartConfig.chart_type === "spark_pie") {
        config.series = seriesData[0].data;
        config.options.labels = categories;
        config.options.plotOptions = {
          pie: {
            expandOnClick: true,
            dataLabels: {
              offset: 0
            }
          }
        };
      }

      //show spark_column chart differently
      if (chartConfig.chart_type === "spark_column") {
        config.options.colors = ["#96cffe"];
      }

      break;

    case "donut":
      config.series = seriesData[0].data;
      config.options.chart.type = chartConfig.chart_type;
      config.options.labels = categories;
      config.options.plotOptions = {
        donut: {
          size: "60%",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "22px",
              color: "#000"
            },
            value: {
              show: true,
              fontSize: "16px",
              color: "#000"
            }
          }
        }
      };
      break;

    default:
      console.error("Unknown chart type: " + chartConfig.chart_type);
      break;
  }

  return config;
};

const createSeriesAndCategories = (inputSeries, chartConfig) => {
  const result = { data: [], categories: [] };
  if (chartConfig.type === "2d" || chartConfig.dimension === "2d") {
    const configObj = { name: chartConfig?.data_label, data: [] };

    //required data structure {name:"xyz", data:[1,3,4,5]}
    inputSeries.forEach((axisData) => {
      result.categories.push(axisData[0]);
      configObj.data.push(axisData[1]);
    });

    result.data.push(configObj);
  } else {
    inputSeries[0].shift(); //TODO: ask backend to remove unwanted first element;
    result.categories.push(...inputSeries[0]);

    // required data structure {name:"", data:[{name:"xyz", data:[1,3,4,5], {name:"abc", data:[1,3,4,5]} ]}
    for (let i = 1; i < inputSeries.length; i++) {
      const name = inputSeries[i][0];
      const dataArray = inputSeries[i].slice(1);

      result.data.push({ name, data: dataArray });
    }
  }

  return result;
};

const chartDefaultConfig = {
  series: [],
  options: {
    chart: {
      type: "",
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    dataLabels: {
      enabled: false
    },

    stroke: {
      curve: "straight", // Change to 'straight' if needed
      width: 2
    },
    markers: {
      size: 4,
      strokeWidth: 2,
      hover: {
        size: 8
      }
    },
    colors: [],
    title: {
      text: "",
      align: "center"
    },
    subtitle: {
      text: "",
      align: "center"
    },
    legend: {
      show: true,
      position: "bottom",
      showForSingleSeries: true
    },
    axisBorder: {
      show: true
    },
    grid: {
      show: true,
      row: {
        colors: ["#f3f3f3", "transparent"], // Alternates the row background color
        opacity: 0.5
      }
    },
    labels: [],
    xaxis: {
      categories: [],
      tooltip: { enabled: false },
      axisTicks: {},
      crosshairs: {
        show: false
      },
      axisBorder: {
        show: true
      },
      title: {
        text: ""
      },
      labels: {
        show: true
      }
    },
    yaxis: {
      title: {
        text: ""
      },
      axisTicks: {},
      labels: {
        show: true
      }
    },

    tooltip: {
      shared: true,
      intersect: false
    }
  }
};

let data2D = [
  ["Label 1", 27],
  ["Label 2", 23],
  ["Label 3", 25],
  ["Label 4", 20]
];
let data3D = [
  ["", "Dev A", "Dev B", "Dev C"],
  ["Not connected", 5, 3, 2],
  ["Connected < 20 min", 8, 6, 5],
  ["Connected > 20 min", 6, 9, 12]
];
